export const EVENT_STATUS = {
  bozza: "Bozza",
  iscrizioni_aperte: "Iscrizioni aperte",
  in_programma: "In programma",
  in_corso: "In corso",
  concluso: "Concluso",
  annullato: "Annullato",
  archiviato: "Archiviato",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  staff: "Staff / Event Manager",
  clan_leader: "Leader di clan",
  user: "Utente registrato",
};

export const NEWS_CAT = {
  annunci: "Annunci",
  staff: "Comunicazioni staff",
  eventi: "Nuovi eventi",
  risultati: "Risultati",
  regolamenti: "Regolamenti",
  reclutamento: "Reclutamento",
  alleanza: "Novità alleanza",
};

export const CLAN_KIND = { membro: "Membro ufficiale", ospite: "Ospite", evento: "Partecipante evento" };
export const CLAN_STATUS = { attivo: "Attivo", inattivo: "Inattivo", sospeso: "Sospeso" };
export const PTYPE = { clan: "Clan", team: "Squadra", player: "Giocatore" };
export const TIEBREAKERS = { points: "Punti", wins: "Vittorie", kills: "Eliminazioni", best_placement: "Miglior piazzamento", matches: "Match giocati" };

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d - off).toISOString().slice(0, 16);
}

export function fromLocalInput(v) {
  return v ? new Date(v).toISOString() : null;
}
